import moment from "moment";
import React from "react";
import { useTranslation } from "react-i18next";

export const AllDataForFilters = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "stress-check",
  });
  const { t: t1 } = useTranslation("translation", {
    keyPrefix: "vaccination",
  });

  const monthOptions = [
    {
      id: 0,
      name: t1("unspecified"),
      value: "",
    },
    {
      id: 1,
      name: t("jan"),
      value: 1,
    },
    {
      id: 2,
      name: t("feb"),
      value: 2,
    },
    {
      id: 3,
      name: t("march"),
      value: 3,
    },
    {
      id: 4,
      name: t("april"),
      value: 4,
    },
    {
      id: 5,
      name: t("may"),
      value: 5,
    },
    {
      id: 6,
      name: t("june"),
      value: 6,
    },
    {
      id: 7,
      name: t("july"),
      value: 7,
    },
    {
      id: 8,
      name: t("aug"),
      value: 8,
    },
    {
      id: 9,
      name: t("sep"),
      value: 9,
    },
    {
      id: 10,
      name: t("oct"),
      value: 10,
    },
    {
      id: 11,
      name: t("nov"),
      value: 11,
    },
    {
      id: 12,
      name: t("dec"),
      value: 12,
    },
  ];

  interface YearOption {
    id: number;
    name: string;
    value: number | string;
  }

  const yearOptions: YearOption[] = [
    {
      id: 0,
      name: t1("unspecified"),
      value: "",
    },
  ];

  const currentYear = moment().year();
  const currentMonth = moment().month() + 1;

  for (let i = currentYear; i >= 1900; i--) {
    yearOptions.push({
      id: i,
      name: `${i}${t("start-year")}`,
      value: i,
    });
  }

  return {
    currentYear,
    currentMonth,
    monthOptions,
    yearOptions,
  };
};
